import { useEffect, useState } from 'react';

const useStaticPages = <T extends Record<string, string>>(idToNameMap: T) => {
  const [pages, setPages] = useState<typeof idToNameMap | null>(null);
  useEffect(() => {
    Promise.all(
      Object.values(idToNameMap).map((name) => fetch(`/_${name}.html`).then((r) => r.text())),
    ).then((res) => {
      setPages(Object.fromEntries(res.map((t, i) => [Object.keys(idToNameMap)[i], t])));
    });
  }, [idToNameMap]);
  return pages;
};

export default useStaticPages;
